import { useSearchParams } from "react-router-dom";

export type Platform = "shopify" | "baback-office";

export function usePlatform(): Platform {
  const [params] = useSearchParams();
  return params.get("platform") === "shopify" ? "shopify" : "baback-office";
}
